(() => {
  const shuffleShowcaseProducts = (showcase) => {
    showcase.querySelectorAll('[data-sd-showcase-grid]').forEach((grid) => {
      const products = Array.from(grid.querySelectorAll('[data-sd-showcase-product]'));
      if (products.length < 2) return;

      for (let index = products.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(Math.random() * (index + 1));
        [products[index], products[swapIndex]] = [products[swapIndex], products[index]];
      }

      const slide = grid.closest('[data-sd-showcase-slide]');
      const collectionKey = slide?.dataset.collectionKey || 'collection';
      const storageKey = `seouldepot-showcase-${collectionKey}`;

      try {
        const previousFirst = window.localStorage.getItem(storageKey);
        if (
          previousFirst &&
          products[0]?.dataset.productKey === previousFirst &&
          products.length > 1
        ) {
          [products[0], products[1]] = [products[1], products[0]];
        }
        window.localStorage.setItem(storageKey, products[0]?.dataset.productKey || '');
      } catch {
        // Random selection still works when browser storage is unavailable.
      }

      products.forEach((product) => grid.appendChild(product));
    });
  };

  const initCollectionShowcase = (showcase) => {
    if (showcase.dataset.sdShowcaseReady === 'true') return;
    showcase.dataset.sdShowcaseReady = 'true';

    const slides = Array.from(showcase.querySelectorAll('[data-sd-showcase-slide]'));
    const dots = Array.from(showcase.querySelectorAll('[data-sd-showcase-dot]'));
    const previous = showcase.querySelector('[data-sd-showcase-previous]');
    const next = showcase.querySelector('[data-sd-showcase-next]');
    const pause = showcase.querySelector('[data-sd-showcase-pause]');
    const count = showcase.querySelector('[data-sd-showcase-count]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = showcase.dataset.autoplay === 'true' && !reducedMotion;
    const interval = Math.max(Number(showcase.dataset.interval) || 7000, 5000);
    let current = 0;
    let isPaused = !autoplay;
    let timer;

    shuffleShowcaseProducts(showcase);

    const showSlide = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === current;
        slide.classList.toggle('is-active', isActive);
        slide.hidden = !isActive;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === current;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (count) {
        count.textContent = `${String(current + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      }
    };

    const stopTimer = () => {
      if (timer) window.clearInterval(timer);
      timer = undefined;
    };

    const startTimer = () => {
      stopTimer();
      if (!isPaused && slides.length > 1) {
        timer = window.setInterval(() => showSlide(current + 1), interval);
      }
    };

    previous?.addEventListener('click', () => {
      showSlide(current - 1);
      startTimer();
    });

    next?.addEventListener('click', () => {
      showSlide(current + 1);
      startTimer();
    });

    pause?.addEventListener('click', () => {
      isPaused = !isPaused;
      const playIcon = pause.querySelector('[data-sd-play-icon]');
      const pauseIcon = pause.querySelector('[data-sd-pause-icon]');
      if (playIcon) playIcon.hidden = !isPaused;
      if (pauseIcon) pauseIcon.hidden = isPaused;
      pause.setAttribute(
        'aria-label',
        isPaused ? 'Resume Changing Collections' : 'Pause Changing Collections',
      );
      startTimer();
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showSlide(index);
        startTimer();
      });
    });

    showcase.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showSlide(current - 1);
      if (event.key === 'ArrowRight') showSlide(current + 1);
    });

    showSlide(0);
    startTimer();
  };

  const initBuyerDesk = (desk) => {
    if (desk.dataset.sdBuyerDeskReady === 'true') return;
    desk.dataset.sdBuyerDeskReady = 'true';

    const buttons = desk.querySelectorAll('[data-sd-buyer-option]');
    const target = desk.querySelector('[data-sd-recommendation-links]');

    if (!buttons.length || !target) return;

    const selectOption = (button) => {
      buttons.forEach((item) => {
        const isSelected = item === button;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        const mark = item.querySelector('.sd-buyer-option__mark');
        if (mark) mark.textContent = isSelected ? '✓' : '';
      });

      const picks = button.querySelector('.sd-buyer-option__picks');
      if (picks) target.innerHTML = picks.innerHTML;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => selectOption(button));
    });

    selectOption(buttons[0]);
  };

  const initSeoulDepotHomepage = (root = document) => {
    root.querySelectorAll('[data-sd-collection-showcase]').forEach(initCollectionShowcase);
    root.querySelectorAll('[data-sd-buyer-desk]').forEach(initBuyerDesk);
  };

  document.addEventListener('DOMContentLoaded', () => initSeoulDepotHomepage());
  document.addEventListener('shopify:section:load', (event) => {
    initSeoulDepotHomepage(event.target);
  });
})();
